import React from "react";
import { Button, Form, FormControl, Modal } from "react-bootstrap";
import { ErrorMessages } from "../../components";
import { ApiHelper } from "../../helpers";

interface Props {
  onClose: () => void,
  onDone: (data: string) => void
}

export const OrangeModal: React.FC<Props> = (props: Props) => {

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errors, setErrors] = React.useState<string[]>([]);

  const handleChange = (e: any) => {
    switch (e.currentTarget.id) {
      case "orangeEmail": setEmail(e.currentTarget.value); break;
      case "orangePassword": setPassword(e.currentTarget.value); break;
    }
  }

  const validateForm = () => {
    let errors:string[] = [];
    if (email === "") errors.push("Email is required.");
    if (password === "") errors.push("Password is required.");
    setErrors(errors);
    return errors.length === 0;
  }


  const handleSubmit = async () => {
    if (validateForm()) {
      let errors:string[] = [];
      setIsSubmitting(true);

      try {
        const data = await ApiHelper.post("/orange/login", { email: email, password: password });
        if (data.userId) props.onDone(JSON.stringify(data));
        else throw new Error("Invalid data - " + JSON.stringify(data));
      } catch (err) {
        console.log("ERROR", err);
        errors.push("Invalid email or password.");
      }
      setIsSubmitting(false);
      setErrors(errors);
    }
  }

  //const handleStockSelect = (url: string) => {
    //props.onSelect(url);
  //}

  return (<>
    <Modal id="orangeModal" show={true} dialogClassName="custom-modal" bsClass="my-modal" onHide={props.onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Think Orange Login</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex" }}>
        <div style={{width:"100%"}}>
          
          <div style={{textAlign: "center", margin: "auto"}}>
            <img src="/images/orange-logo.png" style={{width: "300px"}} alt="Orange Logo" />
          </div>
          <p>Please login to your Orange account.</p>
          <ErrorMessages errors={errors} />
          
          <Form.Group className="mb-3">
            <FormControl type="text" aria-label="email" id="orangeEmail" value={email} onChange={handleChange} placeholder="Email address" />
          </Form.Group>
          <Form.Group className="mb-3">
            <FormControl type="password" aria-label="password" id="orangePassword" value={password} onChange={handleChange} placeholder="Password" />
          </Form.Group>
          <Button type="submit" id="signInButton" size="lg" variant="primary" className="d-grid" disabled={isSubmitting} style={{ width: "100%" }} onClick={handleSubmit}>
            {(isSubmitting) ? "Please wait..." : "Sign in"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  </>);
};
